import React, { useEffect, useState } from "react";
import Slider from "react-slick";
import styled from "styled-components";
import tw from "twin.macro";

import news1 from "images/yenimahalle/news_1.jpg";
import news2 from "images/yenimahalle/news_2.jpg";
import news3 from "images/yenimahalle/news_3.jpg";
import news4 from "images/yenimahalle/news_4.jpg";
import news5 from "images/yenimahalle/news_5.jpg";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import PortalApi from "api/PortalApi";
import { HomePageNew, NewsList } from "models/Response/Portal";
import { dateFormatter } from "utils/dateFormatter";
import { slugify } from "utils/slugify";

const FullWidthSection = tw.section`w-full relative`;

const StyledSlider = styled(Slider)`
  .slick-list {
    ${tw`overflow-visible`}
  }
  .slick-dots {
    ${tw`mb-4`}
    li button:before {
      ${tw`text-primary-500`}
    }
    li.slick-active button:before {
      ${tw`text-primary-700`}
    }
  }
`;

const Slide = tw.div`
  flex! 
  flex-col md:flex-row
  items-center md:items-stretch
  justify-center
  outline-none 
  p-4
`;

const ImageContainer = styled.div`
  ${tw`w-full md:w-4/12 mx-3 flex items-center justify-center`}
  img {
    ${tw`rounded w-full`}
  }
`;

const TextContainer = tw.div`
  w-full md:w-6/12 
  mx-3 
  py-4 
  flex flex-col 
  justify-center 
  text-center md:text-left
`;

const Title = tw.h5`font-bold text-xl lg:text-2xl text-secondary-700`;
const Description = tw.p`mt-3 text-sm md:text-base text-gray-700`;

const Button = tw.a`
  inline-block mt-5 px-6 py-2 
  bg-primary-600 text-gray-100 
  rounded 
  font-semibold
  hover:bg-primary-700 transition duration-300
`;

const ButtonContainer = tw.div`flex mt-8`;

const CenteredButtonContainer = tw.div`flex flex-col text-center justify-center mt-8`;
const AllNewsButton = tw.a`
  inline-block px-8 py-3 
  bg-primary-600 text-white 
  font-semibold 
  hover:bg-primary-700 transition duration-300
`;

// Type tanımı
interface SlideItem {
  imageSrc: string;
  title: string;
  description: string;
  buttonText: string;
  buttonLink: string;
}

const NewsSlider: React.FC = () => {
  const sliderSettings = {
    dots: true,
    infinite: true,
    speed: 600,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
  };
  const [slides, setSlides] = useState<SlideItem[]>([]);

  const fetchNews = async () => {
    const response = await PortalApi.getHomePageData();
    if (response && response.homePageNews) {
      const mappedItems = response.homePageNews.map((item: HomePageNew) => ({
        id: item.newsId,
        imageSrc: item.mainImageUrl || "",
        title: item.title,
        description: item.preText || "",
        buttonText: "Haberin Devamını Okumak İçin Tıklayınız",
        buttonLink: `/HaberDetay/${slugify(item.title)}/${item.newsId}`,
      }));
      setSlides(mappedItems);
    }
  };

  useEffect(() => {
    fetchNews();
  }, []);
  return (
    <FullWidthSection>
      <StyledSlider {...sliderSettings}>
        {slides.map((slide, index) => (
          <Slide key={index}>
            <ImageContainer>
              <img src={slide.imageSrc} alt={slide.title} />
            </ImageContainer>
            <TextContainer>
              <Title>{slide.title}</Title>
              <Description>{slide.description}</Description>
              <ButtonContainer>
                <Button href={slide.buttonLink}>{slide.buttonText}</Button>
              </ButtonContainer>
            </TextContainer>
          </Slide>
        ))}
      </StyledSlider>

      <CenteredButtonContainer>
        <AllNewsButton href="/TumHaberler">Tüm Haberleri Görüntüle</AllNewsButton>
      </CenteredButtonContainer>
    </FullWidthSection>
  );
};

export default NewsSlider;
